export const isDisplayedEntryCategory = (category: string) =>
  category === 'FEE' ||
  category === 'TAX' ||
  category === 'LOYALTY' ||
  category === 'ACQUIRING_FEE' ||
  category === 'CASH_ACQUIRING_FEE';
